import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useProfileState } from "../../../hooks/useProfileState";

import { useSharedListStyles } from "../../../shared/useSharedListStyles";
import BimProfileService from "../../../services/BimProfileService";
import LoadingIndicator from "../../../shared/LoadingIndicator";
import {trackPromise} from "react-promise-tracker";
import UserService from "../../../services/UserService";
import BimetaProfilesListView from "./BimetaProfilesListView";



function BimetaProfiles() {
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const [bimetaProfiles, setBimetaProfiles] = useState([]);
    const profile = useProfileState();
    const setBimProfileSelected = profile.setSelected;
    const setBimProfileSelectedData = profile.setSelectedData;

    const classes = useSharedListStyles();

    useEffect(() => {
        if (!UserService.isLoggedIn()) {
            UserService.doLogout();
        }
    }, []);

    const GetProfilesData = useCallback(async () => {
        try {
            const res = await trackPromise(BimProfileService.getBimetaProfiles(token, realm));
            if (res.data) setBimetaProfiles(res.data);
            setBimProfileSelected('');
            setBimProfileSelectedData([]);
        } catch (e) {
            console.error("Fehler beim Laden der Bimeta-Profile:", e);
        }
    }, [setBimetaProfiles, setBimProfileSelected, setBimProfileSelectedData, realm, token]);

    useEffect(() => {
        trackPromise(GetProfilesData());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const addNew = async (rowData) => {
        try {
            const res = await trackPromise(BimProfileService.importBimetaProfiles(token, realm, rowData.id));
            if (res.data) setBimetaProfiles(res.data);
        } catch (e) {
            console.error("Fehler beim Importieren der Bimeta-Profile:", e);
        }
    };

    return (
        <div>
            <LoadingIndicator />
            <div className={classes.katalogView}>
                <div className={classes.btListe}>
                    <BimetaProfilesListView
                        profileList={bimetaProfiles}
                        GetProfilesData={GetProfilesData}
                        addNew={addNew}
                    />
                </div>
            </div>
        </div>
    );
}

export default BimetaProfiles;
